
/// <amd-module name="Build/Common/Library/PipelinesStateData" />
import { IDisposable } from "Build/Flux/Common";

export class PipelinesStateData implements IDisposable{
    private _treeData: string = "";
    public static key = "PipelinesTreeStateDataStore";

    public get treeData(): string {
        return this._treeData;
    }

    public updateTreeData(data: string) {
        this._treeData = data;
    }

    public dispose() {
        this._treeData = "";
    }
}
